<template>
<div class="chapter">
<div class="inner_page">
<div id="contents">
<hr style="margin-bottom:-.1em;"/>
<p class="toc-title" style="font-weight:bold;font-size:1.3em;text-align:left;">CONTENTS</p>
<hr style="margin-top:-.1em;"/>
<p class="paranoindent1" style="margin-top:1em;"><a href="#/text/05_chapter1#ch1" id="toc-ch1">Design</a></p>
<p class="paranoindent1" style="margin-top:1em;"><span href="#/text/06_chapter2#ch2" id="toc-ch2" title="Link target outside of Sample">Careers</span></p>
<p class="paranoindent1" style="margin-top:1em;"><span href="#/text/07_chapter3#ch3" id="toc-ch3" title="Link target outside of Sample">Model Products</span></p>
<p class="paranoindent1" style="margin-top:1em;"><span href="#/text/08_chapter4#ch4" id="toc-ch4" title="Link target outside of Sample">Modelmakers’ Showcase</span></p>
<p class="paranoindent1" style="margin-top:1em;"><span href="#/text/09_chapter5#ch5" id="toc-ch5" title="Link target outside of Sample">Schemes</span></p>
<p class="paranoindent1" style="margin-top:1em;"><span href="#/text/10_chapter6#ch6" id="toc-ch6" title="Link target outside of Sample">Appearance</span></p>
<p class="paranoindent1" style="margin-top:1em;"><span href="#/text/11_chapter7#ch7" id="toc-ch7" title="Link target outside of Sample">Plans</span></p>
<p class="paranoindent1" style="margin-top:1em;"><span href="#/text/12_chapter8#ch8" id="toc-ch8" title="Link target outside of Sample"><em>U 995</em>: Last of Many</span></p>
<p class="paranoindent1" style="margin-top:1em;"><span href="#/text/13_selected_references#ref" id="toc-ref" title="Link target outside of Sample">Selected References</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_contents.vue?f2e15b9c